const depotPlantType = () => ({
  DEPOT: {
    id: 1,
    text: 'Depot',
  },
  RDC: {
    id: 2,
    text: 'Rdc',
  },
  FACTORY: {
    id: 3,
    text: 'Factory',
  },
});

const depotRegionTypes = () => ({
  NORTH: 'North',
  SOUTH: 'South',
  EAST: 'East',
  WEST: 'West',
});

const DepotConstants = {
  DeliveryType: {
    SHIPPER: 1,
    CUSTOMER: 2,
    COMAKER: 3,
    HUB: 4,
  },
  validDepotHeaders: {
    'Depot Name': 'name',
    'Reference Id': 'reference_id',
    Address: 'address',
    City: 'city',
    State: 'state',
    Pincode: 'pincode',
    Region: 'region',
    'GST IN': 'gstn_no',
    Phone: 'phone',
    'Delivery Type': 'delivery_type',
    'Short Code': 'short_code',
    'Manager email ids': 'manager_email_ids',
    'Depot type': 'plant_type',
    'Display Reference Name': 'display_reference_name',
  },
  validOptionalDepotHeaders: {
    'Ports Associated': 'ports_associated',
    'Overseas Customer': 'overseas_customer',
    'Fax Number': 'fax_number',
    Timezone: 'timezone',
    'Associated Material Categories': 'associated_material_categories',
  },
  validOptionalVendorDepotHeaders: {
    'Ports Associated': 'ports_associated',
    'Fax Number': 'fax_number',
    Timezone: 'timezone',
    'Overseas Customer': 'overseas_customer'
  },
  validVendorDepotHeaders: {
    'Depot Name*': 'name',
    'Reference Id*': 'reference_id',
    'Address*': 'address',
    'City*': 'city',
    'State*': 'state',
    'Pincode*': 'pincode',
    'Region*': 'region',
    'GST IN*': 'gstn_no',
    'Phone': 'phone',
    'Delivery Type*': 'delivery_type',
    'Short Code*': 'short_code',
    'Manager email ids*': 'manager_email_ids',
    'Display Reference Name': 'display_reference_name',
  },
};
const plantType = {
  1: 'Depot',
  2: 'RDC',
  3: 'Factory',
};

module.exports = {
  depotPlantType,
  depotRegionTypes,
  DepotConstants,
  plantType,
};
